import axios from './index';

export const getVendorRequest = () => axios.get('/v1/vendors/get/vendor');

export const updateVendorRequest = (reqObj) => axios.put(`/v1/vendors/update/vendor`, reqObj);

export const updateVendorPasswordRequest = (reqObj) =>
  axios.put(`/v1/vendors/update/vendor/password`, reqObj);
